import styled from 'styled-components';
import { Colors, FontSize, FontWeight, Spacing } from '../../assets/GlobalStyle/Variables';

export const DeceasedContainer = styled.div`
  padding: 1.5rem 2rem;
  background: linear-gradient(to bottom, #f8f5fa 0%, #ffffff 100%);
  min-height: calc(100vh - 68px);
`;

export const FormCard = styled.div`
  background: ${Colors.white};
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-top: 1.5rem;
`;

export const SectionTitle = styled.h3`
  color: ${Colors.mainText};
  font-size: ${FontSize.subTitle};
  font-weight: 600;
  margin: 2rem 0 1.5rem 0;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid ${Colors.lightBackground};
  display: flex;
  align-items: center;
  gap: 0.75rem;

  &:first-of-type {
    margin-top: 0;
  }

  svg {
    color: ${Colors.primary};
  }
`;

export const StyledPageTitle = styled.div`
  background: linear-gradient(135deg, ${Colors.primary} 0%, ${Colors.secondary} 100%);
  border-radius: 12px;
  padding: 1.5rem 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  h1 {
    color: ${Colors.white};
    font-size: ${FontSize.title};
    font-weight: 600;
    margin: 0;
    letter-spacing: -0.3px;
  }
`;

export const ActionSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-top: ${Spacing(15)};
  padding-top: ${Spacing(10)};
  border-top: 1px solid ${Colors.lightGrey};
`;

export const PrimaryActionButton = styled.button`
  background: linear-gradient(135deg, ${Colors.primary} 0%, ${Colors.secondary} 100%);
  color: ${Colors.white};
  border: none;
  padding: 12px 32px;
  font-size: ${FontSize.normal};
  font-weight: 600;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SecondaryActionButton = styled.button`
  background: ${Colors.white};
  color: ${Colors.grey};
  border: 2px solid ${Colors.lightGrey};
  padding: 12px 32px;
  font-size: ${FontSize.normal};
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: ${Colors.lightGrey};
    border-color: ${Colors.grey};
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const FindButton = styled.button`
  background: ${Colors.primary};
  color: ${Colors.white};
  border: none;
  padding: 10px 20px;
  font-size: ${FontSize.medium};
  font-weight: 600;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease;
  white-space: nowrap;
  height: 38px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover:not(:disabled) {
    background: ${Colors.secondary};
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  }

  &:disabled {
    background: ${Colors.disabled};
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const BabyAgeInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${Spacing(8)};
`;

export const BabyAgeLabel = styled.span`
  color: ${Colors.grey};
  font-weight: ${FontWeight.strong};
  font-size: ${FontSize.normal};
`;

export const BabyAgeValue = styled.span`
  color: ${Colors.mainText};
  font-size: ${FontSize.normal};
  font-weight: ${FontWeight.normal};
`;
